import React, { useState, useEffect, useContext } from "react";
//import Breadcrumb from "../../components/common/Breadcrumb";
// import WelcomeHeader from "../../components/common/WelcomeHeader";
//import { IconBrandTwitterFilled, IconPencil } from "@tabler/icons-react";
//import { profile_av } from "../../assets/images";
import { UserServiceContext } from "../../services/user/userService";
import Loader from "../../components/Loader";
import CustomAlert from "../../components/CustomAlert";
import MaskedInput from "react-text-mask";
import RecaptchaComponent from "../../components/RecaptchaComponent";
import TwoFactorModal from "../auth/TwoFactorModal";
import { useUserContext } from "../../context/user_context";
import { AuthService } from "../../services/auth/authService";

export default function Setting() {
  const { changePassword, user, loading, changeProfile, smsCode } =
    useContext(UserServiceContext);
  const { captchaState, setCaptchaState } = useUserContext();
  //   const [loading, setLoading] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [fullname, setFullname] = useState("");
  const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiErrors, setApiErrors] = useState({});
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [editPasswordForm, setEditPasswordForm] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });
  const [phone, setPhone] = useState({
    mobilePhone: "",
    recaptchaCode: "",
    smsCode: "",
  });

  const handleChange = (event) => {
    const { value } = event.target;
    setFullname(value);
  };

  const clearPhone = () => {
    setPhone({
      mobilePhone: "",
      recaptchaCode: "",
      smsCode: "",
    });
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    setPhone({ ...phone, mobilePhone: value });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        //setEditUser(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (user) {
      setEditUser(user);
      //console.log(user.fullName);
      if (user.fullName) setFullname(user.fullName);
      if (user.mobile) setPhone({ ...phone, mobilePhone: user.mobile });
    }
  }, [user]);

  useEffect(() => {}, [captchaState]);

  const validateFullname = () => {
    const errors = {};
    if (!fullname.trim()) {
      errors.fullname = "სახელი აუცილებელია.";
    } else if (fullname.length < 3) {
      errors.fullname = "სახელი მინიმუმ 3 სიმბოლოს უნდა შეიცავდეს.";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validatePhone = () => {
    const errors = {};

    if (!/^\d{9}$/.test(phone.mobilePhone)) {
      errors.phone = "ტელეფონის ნომერი უნდა შეიცავდეს 9 ციფრს.";
    }
    // } else if (phone.mobilePhone === user.mobile) {
    //   errors.phone = "ტელეფონის ნომერი არ უნდა ემთხვეოდეს მიმდინარე ნომერს.";
    // }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const openTwoFactorModal = (value) => {
    //console.log(["openTwoFactorModal", value]);
    setShowTwoFactorModal(value ?? !showTwoFactorModal);
  };

  const mustResetCaptcha = () => {
    setResetCaptcha(!resetCaptcha);
  };

  const handleSaveProfile = async (event) => {
    event.preventDefault();
    const isValid = validateFullname();
    if (isValid) {
      // Call the changeProfile function or any other logic to save the profile
      const response = await changeProfile({ fullName: fullname });
      if (response && response.data) {
        if (response.data.success) {
          setAlertConfig({
            show: true,
            title: "Success!",
            text: "პროფილი წარმატებით შეიცვალა",
            icon: "success",
            onConfirm: () => console.log("Confirmed!"),
            onCancel: () => console.log("Canceled!"),
          });
        }
      }
    }
  };

  const validatePasswordForm = () => {
    const { oldPassword, newPassword } = editPasswordForm;
    const errors = {};
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;

    if (!regex.test(newPassword)) {
      errors.newPassword =
        "პაროლი უნდა იყოს მინიმ 6 სიმბოლო, უნდა შეიცავდეს მინიმუმ 1 დიდ და 1 პატარა ასოს და 1 ციფრს";
    }

    if (oldPassword != newPassword) {
      errors.oldPassword = "პაროლები არ ემთხვევა";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setEditPasswordForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    const isValid = validatePasswordForm();

    if (!isValid) return;

    const response = await changePassword(editPasswordForm);
    if (response && response.data) {
      if (response.data.success) {
        setEditPasswordForm({
          oldPassword: "",
          newPassword: "",
        });
        setAlertConfig({
          show: true,
          title: "Success!",
          text: "პაროლი წარმატებით შეიცვალა",
          icon: "success",
          onConfirm: () => console.log("Confirmed!"),
          onCancel: () => console.log("Canceled!"),
        });
      } else {
        if (response.data.message) {
          setErrors({ oldPassword: response.data.message });
        }
      }
    }
    //console.log(isValid);
  };

  const closeAlert = () => {
    setAlertConfig({ ...alertConfig, show: false });
  };

  const handlePhoneSubmit = async (event) => {
    event.preventDefault();

    const isValid = validatePhone();
    if (isValid) {
      setResetCaptcha(!resetCaptcha);
      const response = await smsCode({
        ...phone,
        recaptchaCode: captchaState.token,
      });
      if (response && response.data) {
        if (response.data.success) {
          setAlertConfig({
            show: true,
            title: "Success!",
            text: "სმს კოდი გაიგზავნა",
            icon: "success",
            onConfirm: () => console.log("Confirmed!"),
            onCancel: () => setShowTwoFactorModal(true),
          });
        } else {
          setAlertConfig({ ...alertConfig, show: false });
          if (response.data.message) {
            setErrors({ phone: response.data.message });
          }
          if (response.data.code === -3) {
            console.log("showTwoFactorModal");
            openTwoFactorModal(true);
          }
        }
      }
    }
  };

  const breadcrumbItem = [
    {
      name: "Account",
    },
    {
      name: "Setting",
    },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <AuthService>
        <CustomAlert {...alertConfig} />
        {showTwoFactorModal && (
          <TwoFactorModal
            setCreateEventModal={openTwoFactorModal}
            formData={phone}
            askSms={true}
            setFormData={setPhone}
            apiErrors={apiErrors}
            setApiErrors={setApiErrors}
            authType="changePhone"
            resetCaptcha={mustResetCaptcha}
            clearFormData={clearPhone}
            closeAlert={closeAlert}
          />
        )}
      </AuthService>
      <div className="md:px-6 sm:px-3 pt-4">
        <div className="container-fluid">
          {/* <Breadcrumb breadcrumbItem={breadcrumbItem} /> */}
          {/* <WelcomeHeader income /> */}
          <div className="grid lg:grid-cols-[1fr_2.5fr] grid-cols-1 gap-6 items-start">
            <ul className="card bg-card-color md:sticky md:top-100 border border-dashed border-border-color rounded-md">
              <li className="border-b border-dashed border-border-color last:border-none">
                <a href="#accountSettingProfile" className="block py-3 px-4">
                  პროფილის დეტალები
                </a>
              </li>
              <li className="border-b border-dashed border-border-color last:border-none">
                <a
                  href="#accountPhoneNumberSetting"
                  className="block py-3 px-4"
                >
                  ტელეფონის ნომრის შეცვლა
                </a>
              </li>
              <li className="border-b border-dashed border-border-color last:border-none">
                <a href="#accountSettingPassword" className="block py-3 px-4">
                  პაროლის შეცვლა
                </a>
              </li>

              {/* 
            <li className="border-b border-dashed border-border-color last:border-none">
              <a href="#socialProfileSetting" className="block py-3 px-4">
                Social Profiles
              </a>
            </li> */}
            </ul>
            <div className="flex flex-col md:gap-12 gap-6">
              <form
                onSubmit={handleSaveProfile}
                id="accountSettingProfile"
                className="relative rounded-xl border border-dashed border-border-color p-4"
              >
                <span className="bg-body-color text-font-color-100 px-5 font-semibold absolute top-[-14px]">
                  პროფილის დეტალები
                </span>
                <div className="card bg-card-color rounded-xl">
                  <div className="md:p-6 p-4 flex flex-col gap-4">
                    <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
                      <label>პირადი/საიდენტიფიკაციო ნომერი</label>
                      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                        <div className="form-control">
                          <input
                            type="text"
                            className="form-input"
                            placeholder="ID"
                            defaultValue={user && user.personalId}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:p-6 p-4 flex flex-col gap-4">
                    <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
                      <label>სახელი *</label>
                      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                        <div className="form-control">
                          <input
                            type="text"
                            className="form-input"
                            name="fullname"
                            value={fullname}
                            onChange={(e) => handleChange(e)}
                          />
                          {errors.fullname && (
                            <div className="text-danger text-[14px]/[20px]">
                              {errors.fullname}
                            </div>
                          )}
                        </div>
                        {/* <div className="form-control">
                        <input
                          type="text"
                          className="form-input"
                          placeholder="Morise"
                          defaultValue="Morise"
                        />
                      </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="md:p-6 p-4 flex justify-end flex-wrap gap-4 border-t border-dashed border-border-color">
                    {/* <button className="btn btn-white !border-border-color large">
                      Discard
                    </button> */}
                    <button type={"submit"} className="btn btn-primary large">
                      შენახვა
                    </button>
                  </div>
                </div>
              </form>
              <form
                id="accountPhoneNumberSetting"
                className="relative rounded-xl border border-dashed border-border-color p-4"
                onSubmit={handlePhoneSubmit}
              >
                <span className="bg-body-color text-font-color-100 px-5 font-semibold absolute top-[-14px]">
                  ტელეფონის ნომრის შეცვლა
                </span>
                <div className="card bg-card-color rounded-xl">
                  <div className="md:p-6 p-4 flex flex-col gap-4">
                    <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
                      <label>ტელეფონის ნომერი</label>
                      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                        <div className="form-control">
                          <MaskedInput
                            mask={[
                              "(",
                              /[0-9]/,
                              /\d/,
                              /\d/,
                              ")",
                              " ",
                              /\d/,
                              /\d/,
                              /\d/,
                              "-",
                              /\d/,
                              /\d/,
                              /\d/,
                            ]}
                            guide={true}
                            id="phone"
                            className="form-input"
                            required
                            type="text"
                            placeholder="(555) 555-555"
                            name="mobile"
                            onChange={handlePhoneChange}
                            autoComplete="off"
                            value={phone.mobilePhone}
                          ></MaskedInput>
                          {errors.phone && (
                            <div className="text-danger text-[14px]/[20px]">
                              {errors.phone}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
                      <label>&nbsp;</label>
                      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                        <RecaptchaComponent reset={resetCaptcha} />
                      </div>
                    </div>
                  </div>
                  <div className="md:p-6 p-4 flex justify-end flex-wrap gap-4 border-t border-dashed border-border-color">
                    {/* <button className="btn btn-white !border-border-color large">
                      Discard
                    </button> */}
                    <button type={"submit"} className="btn btn-primary large">
                      შენახვა
                    </button>
                  </div>
                </div>
              </form>
              <form
                onSubmit={handleChangePassword}
                id="accountSettingPassword"
                className="relative rounded-xl border border-dashed border-border-color p-4"
              >
                <span className="bg-body-color text-font-color-100 px-5 font-semibold absolute top-[-14px]">
                  პაროლის შეცვლა
                </span>
                <div className="card bg-card-color rounded-xl">
                  <div className="md:p-6 p-4">
                    {/* <div className="grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                    <div className="form-control">
                      <input
                        type="text"
                        className="form-input"
                        placeholder="louispierce"
                        defaultValue="louispierce"
                        disabled
                      />
                    </div>
                    <div className="form-control">
                      <input
                        type="text"
                        className="form-input"
                        placeholder="louis.info@yourdomain.com"
                        defaultValue="louis.info@yourdomain.com"
                      />
                    </div>
                    <div className="form-control">
                      <input
                        type="number"
                        className="form-input"
                        placeholder="Phone Number"
                      />
                    </div>
                  </div> */}
                    {/* md:mt-6 mt-4  */}
                    <div>
                      <p className="py-2">პაროლის შეცვლა</p>
                      {/* <div className="form-control mb-4">
                      <input
                        type="password"
                        className="form-input"
                        placeholder="Current Password"
                      />
                    </div> */}
                      <div className="form-control mb-1">
                        <input
                          type="password"
                          className="form-input"
                          placeholder="ახალი პაროლი"
                          name="newPassword"
                          value={editPasswordForm.newPassword}
                          onChange={(e) => handlePasswordChange(e)}
                        />
                        {errors.newPassword && (
                          <div className="text-danger text-[14px]/[20px]">
                            {errors.newPassword}
                          </div>
                        )}
                      </div>
                      <div className="form-control">
                        <input
                          type="password"
                          className="form-input"
                          placeholder="გაიმეორეთ პაროლი"
                          name="oldPassword"
                          value={editPasswordForm.oldPassword}
                          onChange={(e) => handlePasswordChange(e)}
                        />
                        {errors.oldPassword && (
                          <div className="text-danger text-[14px]/[20px]">
                            {errors.oldPassword}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="md:p-6 p-4 flex justify-end flex-wrap gap-4 border-t border-dashed border-border-color">
                    {/* <button className="btn btn-white !border-border-color large">
                    Discard
                  </button> */}
                    <button className="btn btn-primary large" type={"submit"}>
                      შენახვა
                    </button>
                  </div>
                </div>
              </form>

              {/* <div
              id="accountNotificationSetting"
              className="relative rounded-xl border border-dashed border-border-color p-4"
            >
              <span className="bg-body-color text-font-color-100 px-5 font-semibold absolute top-[-14px]">
                Notifications Settings
              </span>
              <div className="card bg-card-color rounded-xl">
                <div className="md:p-6 p-4">
                  <div className="overflow-auto">
                    <table className="w-full min-w-[400px]">
                      <tbody>
                        <tr className="border-b border-dashed border-border-color last:border-b-0">
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0 text-font-color-100">
                            Email Notifications
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="emailNotiSettingEmail"
                                className="form-check-input"
                                defaultChecked
                              />
                              <label
                                htmlFor="emailNotiSettingEmail"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Email
                              </label>
                            </div>
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="emailNotiSettingPhone"
                                className="form-check-input"
                                defaultChecked
                              />
                              <label
                                htmlFor="emailNotiSettingPhone"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Phone
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b border-dashed border-border-color last:border-b-0">
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0 text-font-color-100">
                            Billing Updates
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="billNotiSettingEmail"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="billNotiSettingEmail"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Email
                              </label>
                            </div>
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="billNotiSettingPhone"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="billNotiSettingPhone"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Phone
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b border-dashed border-border-color last:border-b-0">
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0 text-font-color-100">
                            New Team Members
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="newMemberNotiSettingEmail"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="newMemberNotiSettingEmail"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Email
                              </label>
                            </div>
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="newMemberNotiSettingPhone"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="newMemberNotiSettingPhone"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Phone
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b border-dashed border-border-color last:border-b-0">
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0 text-font-color-100">
                            Projects Complete
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="projectNotiSettingEmail"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="projectNotiSettingEmail"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Email
                              </label>
                            </div>
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="projectNotiSettingPhone"
                                className="form-check-input"
                                defaultChecked
                              />
                              <label
                                htmlFor="projectNotiSettingPhone"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Phone
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr className="border-b border-dashed border-border-color last:border-b-0">
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0 text-font-color-100">
                            Newsletters
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="newsletterNotiSettingEmail"
                                className="form-check-input"
                              />
                              <label
                                htmlFor="newsletterNotiSettingEmail"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Email
                              </label>
                            </div>
                          </td>
                          <td className="py-3 px-4 border-e border-dashed border-border-color last:border-e-0">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="newsletterNotiSettingPhone"
                                className="form-check-input"
                                defaultChecked
                              />
                              <label
                                htmlFor="newsletterNotiSettingPhone"
                                className="form-check-label !text-[16px]/[24px]"
                              >
                                Phone
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="md:p-6 p-4 flex justify-end flex-wrap gap-4 border-t border-dashed border-border-color">
                  <button className="btn btn-white !border-border-color large">
                    Discard
                  </button>
                  <button className="btn btn-primary large">
                    Save Changes
                  </button>
                </div>
              </div>
            </div> */}
              {/* <div
              id="socialProfileSetting"
              className="relative rounded-xl border border-dashed border-border-color p-4"
            >
              <span className="bg-body-color text-font-color-100 px-5 font-semibold absolute top-[-14px]">
                Social Profiles
              </span>
              <div className="card bg-card-color rounded-xl">
                <div className="md:p-6 p-4">
                  <div className="form-control mb-4">
                    <label className="mb-2 inline-block">Twitter</label>
                    <input type="text" className="form-input" />
                    <button className="btn btn-info my-5">
                      <IconBrandTwitterFilled className="w-[16px] h-[16px] min-w-[16px]" />
                      Connect to Twitter
                    </button>
                    <div className="small text-font-color-100">
                      One-click sign in
                    </div>
                  </div>
                  <div className="form-control mb-4">
                    <label className="mb-2 inline-block">Facebook</label>
                    <input type="text" className="form-input" />
                  </div>
                  <div className="form-control mb-4">
                    <label className="mb-2 inline-block">Behance</label>
                    <input type="text" className="form-input" />
                  </div>
                  <div className="form-control mb-4">
                    <label className="mb-2 inline-block">LinkedIn</label>
                    <input type="text" className="form-input" />
                  </div>
                </div>
                <div className="md:p-6 p-4 flex justify-end flex-wrap gap-4 border-t border-dashed border-border-color">
                  <button className="btn btn-white !border-border-color large">
                    Discard
                  </button>
                  <button className="btn btn-primary large">
                    Update Social Profiles
                  </button>
                </div>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

{
  /* 
  
  <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
                    <label>Avatar</label>
                    <div className="sm:w-[120px] sm:h-[120px] sm:min-w-[120px] w-[100px] h-[100px] min-w-[100px] relative">
                      <img
                        src={editUser}
                        alt="avatar"
                        width="120"
                        height="120"
                        className="w-full h-full object-cover rounded-xl"
                      />
                      <button className="absolute sm:right-10 sm:bottom-10 right-5 bottom-5 p-5 shadow-lg bg-white rounded-full">
                        <input
                          type="file"
                          id="editProfile"
                          onChange={handleFileChange}
                          className="opacity-0 absolute left-0 top-0 w-full h-full cursor-pointer"
                        />
                        <label
                          htmlFor="editProfile"
                          className="opacity-0 absolute left-0 top-0 w-full h-full cursor-pointer"
                        />
                        <IconPencil className="w-[16px] h-[16px]" />
                      </button>
                    </div>
                  </div>
  <div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Company *</label>
<div className="form-control">
  <input
    type="text"
    className="form-input"
    placeholder="swtift pro"
    defaultValue="swtift pro"
  />
</div>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Contact Phone *</label>
<div className="form-control">
  <input
    type="text"
    className="form-input"
    placeholder="+01 (741) 852 123"
    defaultValue="+01 (741) 852 123"
  />
</div>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Company Site</label>
<div className="form-control">
  <input
    type="text"
    className="form-input"
    placeholder="www.swtiftpro.com"
    defaultValue="www.swtiftpro.com"
  />
</div>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Country *</label>
<select className="form-select cursor-pointer rounded-md bg-card-color py-3 ps-15 pe-30 text-[14px]/[20px] appearance-none border border-border-color focus:outline-0 focus:border-primary">
  <option value="">-- Select Country --</option>
  <option value="AF">Afghanistan</option>
  <option value="AX">Åland Islands</option>
  <option value="AL">Albania</option>
</select>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>State/Province *</label>
<select className="form-select cursor-pointer rounded-md bg-card-color py-3 ps-15 pe-30 text-[14px]/[20px] appearance-none border border-border-color focus:outline-0 focus:border-primary">
  <option>California</option>
  <option>Alaska</option>
  <option>Åland Islands</option>
  <option>Alabama</option>
</select>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Time Zone *</label>
<select className="form-select cursor-pointer rounded-md bg-card-color py-3 ps-15 pe-30 text-[14px]/[20px] appearance-none border border-border-color focus:outline-0 focus:border-primary">
  <option value="">Select a Timezone..</option>
  <option value="International Date Line West">
    (GMT-11:00) International Date Line West
  </option>
  <option value="Midway Island">
    (GMT-11:00) Midway Island
  </option>
  <option value="Samoa">(GMT-11:00) Samoa</option>
</select>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Communication *</label>
<div className="flex gap-6 flex-wrap">
  <div className="form-check">
    <input
      type="checkbox"
      id="accountSettingPhone"
      className="form-check-input"
    />
    <label
      htmlFor="accountSettingPhone"
      className="form-check-label !text-[16px]/[24px]"
    >
      Phone
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      id="accountSettingEmail"
      className="form-check-input"
    />
    <label
      htmlFor="accountSettingEmail"
      className="form-check-label !text-[16px]/[24px]"
    >
      Email
    </label>
  </div>
</div>
</div>
<div className="grid sm:grid-cols-[1fr_3fr] grid-cols-1 gap-2">
<label>Available for freelance ?</label>
<div className="form-check form-switch">
  <input
    type="checkbox"
    id="accountSettingAvail"
    className="form-check-input"
  />
  <label
    htmlFor="accountSettingAvail"
    className="form-check-label !text-[16px]/[24px]"
  >
    Yes, advertise my availability on my profile page
  </label>
</div>
</div> */
}
